import {Component} from '@angular/core';

@Component({
  selector: 'app-ts-v2-testimonials-section',
  templateUrl: './testimonials-section.component.html',
  styleUrls: ['./testimonials-section.component.scss'],
})
export class V2TestimonialsSectionComponent {
  testimonials = [
    {
      initials: 'talentSearchV2.testimonials.t1Badge',
      avatarBg: '#EDF6FF',
      avatarText: '#353CD8',
      nameKey: 'talentSearchV2.testimonials.t1Name',
      roleKey: 'talentSearchV2.testimonials.t1Role',
      quoteKey: 'talentSearchV2.testimonials.t1Quote',
    },
    {
      initials: 'talentSearchV2.testimonials.t2Badge',
      avatarBg: '#E4FAEB',
      avatarText: '#1A7A2A',
      nameKey: 'talentSearchV2.testimonials.t2Name',
      roleKey: 'talentSearchV2.testimonials.t2Role',
      quoteKey: 'talentSearchV2.testimonials.t2Quote',
    },
    {
      initials: 'talentSearchV2.testimonials.t3Badge',
      avatarBg: '#FEF3C7',
      avatarText: '#92400E',
      nameKey: 'talentSearchV2.testimonials.t3Name',
      roleKey: 'talentSearchV2.testimonials.t3Role',
      quoteKey: 'talentSearchV2.testimonials.t3Quote',
    },
  ];
}
